import api from '@/configs/GlobalRequestHandler.js';

const SettingsHttp = {
  getSettings: () => {
    return api.getRequest("/settings");
  },
  getAdminSettings: () => {
    return api.getRequest("/admin/settings");
  },
  updateSettings: (data) => {
    return api.putRequestWithBody("/admin/settings", data);
  },
};

export default SettingsHttp;
